{
  "tabs": {
    "chat": "Chat",
    "reminders": "Podsjetnici",
    "calendar": "Kalendar",
    "settings": "Postavke"
  },
  "common": {
    "cancel": "Otkaži",
    "save": "Sačuvaj",
    "confirm": "Potvrdi",
    "delete": "Obriši",
    "back": "Nazad",
    "close": "Zatvori",
    "edit": "Uredi",
    "search": "Pretraži",
    "all": "Sve",
    "loading": "Učitavanje...",
    "error": "Nešto je pošlo po zlu",
    "notFound": "Nije pronađeno",
    "tryAgain": "Pokušajte ponovo",
    "retry": "Pokušaj ponovo",
    "undo": "Poništi",
    "pullToRefresh": "Povuci za osvježavanje",
    "justNow": "upravo sada"
  },
  "auth": {
    "welcome": "Dobrodošli u FishMemory",
    "tagline": "Vaš WhatsApp asistent za podsjetnike, sada u vašem džepu.",
    "subtitle": "Vaš WhatsApp asistent za podsjetnike, sada u vašem džepu.",
    "phoneLabel": "Vaš WhatsApp broj",
    "phoneHint": "Poslat ćemo vam verifikacijski kod putem WhatsAppa",
    "invalidPhone": "Unesite važeći broj telefona",
    "continue": "Nastavi",
    "enterPhone": "Unesite vaš WhatsApp broj",
    "phonePlaceholder": "Broj telefona",
    "sendCode": "Pošalji kod",
    "verifyTitle": "Potvrdite svoj broj",
    "otpSentTo": "6-znamenkasti kod je poslan na {{phone}} putem WhatsAppa",
    "enterFullCode": "Unesite svih 6 cifara",
    "invalidOtp": "Nevažeći kod. Pokušajte ponovo.",
    "otpFailed": "Slanje koda nije uspjelo. Pokušajte ponovo.",
    "otpResent": "Kod ponovo poslan",
    "resendIn": "Ponovo pošalji za {{seconds}}s",
    "resendCode": "Ponovo pošalji kod",
    "enterOtp": "Unesite kod poslan na vaš WhatsApp",
    "verify": "Potvrdi",
    "resend": "Ponovo pošalji kod",
    "wrongNumber": "Pogrešan broj?",
    "backToPhone": "Nazad na broj",
    "editPhone": "Uredi broj telefona",
    "error": "Greška",
    "setupTitle": "Postavimo stvari",
    "setupSubtitle": "Uvijek možete promijeniti ovo kasnije u Postavkama",
    "namePlaceholder": "Vaše ime",
    "letsGo": "Završi postavljanje",
    "skipForNow": "Preskoči za sada"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Napišite poruku...",
    "inputPlaceholder": "Napišite poruku...",
    "typing": "FishMemory piše...",
    "online": "Online",
    "connecting": "Povezivanje...",
    "reconnecting": "Ponovno povezivanje...",
    "offline": "Offline",
    "empty": "Započni razgovor",
    "emptyHint": "Kreirajte podsjetnike, provjerite raspored ili zatražite pomoć.",
    "emptyAction": "Pošalji primjer podsjetnika",
    "actions": "Radnje u chatu",
    "keep": "Sačuvaj poruke",
    "clearTitle": "Obriši chat",
    "clearConfirm": "Obrisati sve poruke sa ovog uređaja? Ovo se ne može poništiti.",
    "clear": "Obriši chat",
    "optionSelected": "Izabrano: {{label}}",
    "sendingSelection": "Šalje se...",
    "connectionLost": "Ponovno povezivanje..."
  },
  "reminders": {
    "title": "Moji podsjetnici",
    "active": "Aktivni",
    "today": "Danas",
    "thisWeek": "Ove sedmice",
    "history": "Istorija",
    "items": "stavke",
    "emptyTitle": "Još nema podsjetnika",
    "emptySubtitle": "Kreirajte jedan u chatu i pojavit će se ovdje.",
    "emptyAction": "Otvori chat",
    "filterActive": "Aktivni",
    "filterToday": "Danas",
    "filterWeek": "Ove sedmice",
    "filterHistory": "Istorija",
    "emptyState": "Još nema podsjetnika. Počnite razgovor!",
    "swipeDone": "Završeno",
    "swipeSnooze": "Odgodi",
    "swipeDelete": "Obriši",
    "search": "Pretraži podsjetnike...",
    "upcoming": "Nadolazeći",
    "completed": "Završeni",
    "overdue": "Istekli",
    "tomorrow": "Sutra",
    "synced": "Sinkronizirano {{value}}",
    "swipeHint": "Prevucite podsjetnik za više opcija",
    "noResults": "Nema podsjetnika koji odgovaraju pretrazi",
    "noResultsHint": "Probajte drugu riječ ili očistite pretragu",
    "deleteAllFailed": "Brisanje svih podsjetnika nije uspjelo"
  },
  "calendar": {
    "title": "Kalendar",
    "today": "Danas",
    "tomorrow": "Sutra",
    "completed": "završeno",
    "noEvents": "Nema zakazanih događaja",
    "noEventsSubtitle": "Izaberite datum da vidite podsjetnike i događaje u kalendaru.",
    "googleEvent": "Google Kalendar",
    "legendActive": "Aktivno",
    "legendRecurring": "Ponavljajuće",
    "legendDone": "Završeno",
    "legendGoogle": "Google",
    "previousMonth": "Prethodni mjesec",
    "nextMonth": "Sljedeći mjesec",
    "previousYear": "Prethodna godina",
    "nextYear": "Sljedeća godina",
    "goToToday": "Idi na danas",
    "all": "Sve",
    "active": "Aktivno",
    "done": "Završeno",
    "paused": "Pauzirano"
  },
  "settings": {
    "title": "Postavke",
    "profile": "Profil",
    "name": "Ime za prikaz",
    "enterName": "Unesite ime",
    "language": "Jezik",
    "uiLanguage": "Jezik aplikacije",
    "uiLanguageHelp": "Mijenja jezik sučelja, oznake kalendara i smjer rasporeda samo na ovom uređaju.",
    "serverLanguage": "Jezik chata",
    "serverLanguageHelp": "Mijenja jezik koji koristi server za odgovore i poruke podsjetnika za vaš račun.",
    "timezone": "Vremenska zona",
    "currentTimezone": "Trenutna vremenska zona",
    "timezoneHelp": "Sva vremena podsjetnika prikazuju se prema ovoj vremenskoj zoni.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Sačuvaj vremensku zonu",
    "timezoneSaved": "Vremenska zona ažurirana",
    "detect": "Detektuj",
    "detectFailed": "Nije moguće detektovati vremensku zonu",
    "autoDetect": "Automatski detektuj preko GPS-a",
    "notifications": "Obavještenja",
    "notificationsHelp": "Podsjetnici za praćenje kontrolišu ponovljene obavijesti nakon što je podsjetnik isporučen. Dozvole za obavještenja na nivou uređaja i dalje se upravljaju u postavkama telefona.",
    "pushEnabled": "Push obavještenja",
    "autoDoneOnFire": "Automatski označi kao završeno kada se aktivira",
    "autoDoneOnFireDesc": "Kada je isključeno, podsjetnici ostaju aktivni dok ih ne označite kao završene.",
    "googleCalendar": "Google Kalendar",
    "google": "Google Kalendar",
    "googleConnected": "Povezano",
    "googleDisconnected": "Nije povezano",
    "googleConnectedHelp": "Novi podsjetnici mogu se automatski sinkronizovati sa vašim kalendarom.",
    "googleDisconnectedHelp": "Povežite Google Kalendar da bi podsjetnici i događaji bili usklađeni.",
    "googleConnectFailed": "Povezivanje Google Kalendara nije uspjelo",
    "connected": "Povezano",
    "disconnected": "Nije povezano",
    "connect": "Poveži",
    "disconnect": "Isključi",
    "autoSync": "Automatska sinkronizacija novih podsjetnika",
    "autosync": "Automatska sinkronizacija novih podsjetnika",
    "subscription": "Pretplata",
    "trialUsed": "Probno: {{used}}/{{total}} iskorišteno",
    "trialStatus": "Probna verzija dostupna",
    "activeStatus": "Aktivna pretplata",
    "expiredStatus": "Pretplata istekla",
    "unsubscribedStatus": "Nije pretplaćeno",
    "about": "O aplikaciji",
    "version": "Verzija",
    "logout": "Odjavi se",
    "logoutTitle": "Odjava",
    "logoutConfirm": "Jeste li sigurni da želite da se odjavite?",
    "noName": "Ime nije postavljeno",
    "serverConnection": "Veza sa serverom",
    "serverUrl": "URL servera",
    "serverEdit": "Uredi",
    "saveReconnect": "Sačuvaj i ponovo poveži",
    "resetDefault": "Vrati na zadano",
    "invalidServerUrlTitle": "Nevažeći URL servera",
    "invalidServerUrlMessage": "Unesite važeći http ili https URL servera, na primjer https://example.com",
    "uiLanguageChangeFailed": "Promjena jezika aplikacije nije uspjela. Pokušajte ponovo.",
    "serverLanguageChangeFailed": "Promjena jezika chata nije uspjela. Pokušajte ponovo.",
    "timezoneChangeFailed": "Promjena vremenske zone nije uspjela. Pokušajte ponovo.",
    "autoSyncChangeFailed": "Ažuriranje automatske sinkronizacije nije uspjelo. Pokušajte ponovo.",
    "nameChangeFailed": "Ažuriranje imena za prikaz nije uspjelo. Pokušajte ponovo.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Detalji podsjetnika",
    "editTime": "Uredi vrijeme",
    "rename": "Preimenuj",
    "snooze": "Odgodi",
    "snooze15": "Odgodi 15 minuta",
    "pause": "Pauziraj",
    "pauseReminder": "Pauziraj podsjetnik",
    "resume": "Nastavi",
    "resumeReminder": "Nastavi podsjetnik",
    "skip": "Preskoči sljedeći",
    "skipOccurrence": "Preskoči ovu pojavu",
    "syncGoogle": "Sinkronizuj sa Google",
    "delete": "Obriši",
    "deleteTitle": "Obriši podsjetnik",
    "deleteConfirm": "Ovaj podsjetnik će biti trajno obrisan.",
    "deleteRecurringTitle": "Obriši ponavljajući podsjetnik",
    "deleteRecurringMessage": "Želite li preskočiti ovu pojavu ili obrisati cijelu seriju?",
    "deleteThisOccurrence": "Preskoči ovu pojavu",
    "deleteEntireSeries": "Obriši cijelu seriju",
    "done": "Završeno",
    "markDone": "Označi kao završeno",
    "undo": "Vrati",
    "undoPrompt": "Treba li ponovo biti aktivan? Vratite ga sada.",
    "recurring": "Ponavljajući",
    "nextRun": "Sljedeće izvršenje",
    "oneTime": "Jednokratni",
    "pending": "Na čekanju",
    "sent": "Poslano",
    "paused": "Pauzirano",
    "active": "Aktivno",
    "snoozed": "Odgodjeno",
    "localTime": "Prikazano u vašem lokalnom vremenu",
    "recurrence": "Ponavljanje",
    "created": "Kreirano",
    "tags": "Oznake",
    "fireCount": "Broj aktiviranja",
    "actions": "Radnje",
    "none": "Nema",
    "snoozeFailed": "Nije uspjelo odgađanje podsjetnika",
    "pauseFailed": "Nije uspjelo pauziranje podsjetnika",
    "resumeFailed": "Nije uspjelo nastavak podsjetnika",
    "skipFailed": "Nije uspjelo preskakanje podsjetnika",
    "doneFailed": "Nije uspjelo označavanje podsjetnika kao završenog",
    "undoFailed": "Nije uspjelo vraćanje statusa podsjetnika",
    "deleteFailed": "Nije uspjelo brisanje podsjetnika",
    "rescheduleTitle": "Prebaci termin?",
    "rescheduleMsg": "Ovaj podsjetnik je istekao. Želite li ga prebaciti na drugi termin?",
    "reschedule15": "Za 15 minuta",
    "reschedule60": "Za 1 sat",
    "keepOverdue": "Ostavi kako jeste"
  },
  "onboarding": {
    "slide1Title": "Dobrodošli u FishMemory",
    "slide1Sub": "Vaš lični asistent za podsjetnike — pokretan WhatsApp-om i napravljen za vaš džep.",
    "slide2Title": "Samo razgovarajte prirodno",
    "slide2Sub": "Kucajte podsjetnike kako mislite: \"Podsjeti me da pozovem mamu sutra u 15h\" — mi ćemo se pobrinuti za ostalo.",
    "slide3Title": "Nikada ništa ne propustite",
    "slide3Sub": "Dobijajte pravovremene obavijesti, organizujte se pomoću oznaka i budite u toku sa svime što vam je važno.",
    "getStarted": "Započni",
    "next": "Dalje",
    "firstReminderTitle": "Kreirajte svoj prvi podsjetnik!",
    "firstReminderHint": "Probajte upisati nešto poput:",
    "firstReminderExample": "Podsjeti me da pijem vodu sutra u 9 sati",
    "gotIt": "Razumio!",
    "notifRationaleTitle": "Budite na vrijeme",
    "notifRationaleBody": "FishMemory treba obavještenja da vas podsjeti na vrijeme. Dobijaćete upozorenja samo za podsjetnike koje kreirate.",
    "notifRationaleAllow": "Omogući obavještenja",
    "notifRationaleLater": "Možda kasnije",
    "swipeHint": "Prevucite desno za brze radnje →",
    "calendarDragHint": "Povucite za proširenje ↕"
  }
}
